<template>
	<div class="row">
		<base-input class="col-md-12"
			v-model="value.bic"
			type="text"
			:name="errorLabel"
			:error="getError(errorLabel)"
			:placeholder="placeholder"
			v-validate="{bic:true}"
		>
			<template v-slot:addonRight>
				<base-button @click="SearchBIC()" simple icon type="primary">
					<i class="tim-icons icon-double-right"></i>
				</base-button>
			</template>
		</base-input>
		<label class="col-form-label col-md-12" >Банк</label>
		<div class="col-md-12">
			<div class="form-group">
				<div class="mb-0">
					<input type="text" placeholder="Банк" class="form-control" v-model="value.bank_name">
				</div>
			</div>
		</div>
		<label class="col-form-label col-md-12" >Корсчет</label>
		<div class="col-md-12">
			<div class="form-group">
				<div class="mb-0">
					<input type="number" placeholder="Корсчет" class="form-control" v-model="value.ks" >
				</div>
			</div>
		</div>
		<label class="col-form-label col-md-12" >Расчетный счет</label>
		<div class="col-md-12">
			<div class="form-group">
				<div class="mb-0">
					<input type="number" placeholder="Расчетный счет" class="form-control" v-model="value.rs">
					<!--lazy change the event listener from input to change-->
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'ReInputBICUr',
		components: {

		},
		props: {
			value: {
				type: Object,
				default: function(){return{
					bic:'',
					bank_name:'',
					ks:'',
					rs: '',
				}}
			},
			findId: { //это свойсво удалять не надо, оно хорошее и моет быть использовано в опуиях для формпринтера или фильтрпринтера
				type: String,
				default: '',
			},
			errorLabel: {
                String,
                default:'БИК',
            },
			placeholder: {
				type: String,
				default: '',
			},
		},
		data () {
			return {
				ver: 1,
			}
		},
		watch:{

		},
		computed: {

		},
		methods: {
			getError(fieldName) {
				return this.errors.first(fieldName);
			},
			SearchBIC(){
				if(this.value.inn != '' && typeof this.getError(this.errorLabel)=='undefined'){
					this.$GVO.ApiCall('GET_BANKINFO_BY_BIC',{obj:'client',flt:{bic:this.value.bic}})
					.then((objApi) => {
						if(objApi.success === true && typeof objApi.data.suggestions != 'undefined' && objApi.data.suggestions.length>0){
							// console.log('SearchBIC',objApi.data.suggestions[0]);
							if(typeof objApi.data.suggestions[0].value != 'undefined' && objApi.data.suggestions[0].value != null)
								this.value.bank_name = objApi.data.suggestions[0].value;

							if(typeof objApi.data.suggestions[0].data.correspondent_account != 'undefined' && objApi.data.suggestions[0].data.correspondent_account != null)
								this.value.ks = objApi.data.suggestions[0].data.correspondent_account;
							
						}
					}).catch(errorObjApi => console.error(errorObjApi));
				}

				
			},

		},
		mounted() {

		}
	}
</script>
<style scoped>
	.btn.btn-icon.btn-simple{margin: 0px;}
</style>
